<div class="d-flex justify-content-between align-items-center mt-4 mb-1">
  <h2 style="margin:0;">
    Upsell Promotion Pipeline
    @if (upsellOffers?.length) {
      <span style="font-size:14px; font-weight:normal; color:#555; margin-left:8px;">
        ({{ upsellOffers.length }} offer{{ upsellOffers.length !== 1 ? 's' : '' }})
      </span>
    }
  </h2>
</div>

<ag-grid-angular
  style="width: auto; height: auto; margin: 4px 0 20px 0;"
  class="ag-theme-balham"
  [gridOptions]="gridOptions"
  [rowData]="upsellOffers"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="onFirstDataRendered($event)"
  (rowGroupOpened)="onRowGroupOpened($event)"
>
</ag-grid-angular>
